module.exports = "/_next/static/images/triplebyte-avatar-c5cc24462d4e168a42bbcf08580e5fd0.png";